import PropTypes from 'prop-types';
import triStateBooleanShape from './TriStateBoolean';
import addressShape from 'react/signups/card/shapes/AddressShape';

const trustDetailsShape = PropTypes.shape({
  trusteeCategory: PropTypes.string,
  businessIsTrustee: PropTypes.bool,
  titleIncludedInList: triStateBooleanShape,
  trusteeTitle: PropTypes.string,
  trusteeName: PropTypes.string,
  trustName: PropTypes.string,
  address: addressShape,
});

export default trustDetailsShape;
